import { classNames } from "primereact/utils";
import { FunctionComponent, PropsWithChildren, ReactNode } from "react";
import { If } from "../If/If";
import classes from "./LabelValue.module.scss";

interface Props {
  label?: string | ReactNode;
  value?: string | number;
  inverseColors?: boolean;
  displayInline?: boolean;
  isRequired?: boolean;
  className?: string;
  bold?: boolean;
}

export const LabelValue: FunctionComponent<PropsWithChildren<Props>> = ({
  className,
  children,
  label,
  value,
  inverseColors = false,
  displayInline = false,
  isRequired = false,
  bold = false,
}) => {
  return (
    <div
      className={classNames(
        classes.container,
        {
          [classes.inverse]: inverseColors,
          [classes.inline]: displayInline,
          [classes.bold]: bold,
        },
        className
      )}
    >
      <div className={classes.label}>
        {label}
        {isRequired ? <span className={classes.requiredIcon}>*</span> : ""}
      </div>
      <div className={classes.value}>
        <If condition={!!children}>
          <>{children}</>
          {value}
        </If>
      </div>
    </div>
  );
};
